export default "__VITE_ASSET__BPUCrTCj__"